export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";